import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { MainAppComponent } from '../../layout/layout.component';
import { ToastrService } from 'ngx-toastr';
import { SpIdAddModel } from '../../common/viewModels/GlobalRegistry/SampPointModel';

declare var $: any;
@Component({
    selector: 'spidchars',
    templateUrl: './spidchars.component.html',
    styleUrls: ['./spidchars.component.scss']
})
export class SpIdCharsComponent implements OnInit {

    lstSpIdChars: any[];
    spId: number;
    spIdAdd: SpIdAddModel = new SpIdAddModel();
    constructor(public _router: Router,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _mApp: MainAppComponent,
        private _toastrService: ToastrService) {
    }

    ngOnInit() {
        this.spId = this._route.snapshot.params['id'];
        this.GetListOfSpIdChars(this.spId);

    }

    GetListOfSpIdChars(spId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfSpIdChars + spId)
            .subscribe(
            data => {
                if (data.json().Result != null) 
                    this.lstSpIdChars = data.json().Result;
                this._mApp.HideLoader();
            },
            error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result, '');
            }
            )
    }

    OnSubmit() {
        this._mApp.ShowLoader();
        this.spIdAdd.SpId = this.spId;
        this.spIdAdd.lstSpIdChars = this.lstSpIdChars;
        this._http.post(this._appUrl.UpsertSpIdChars, this.spIdAdd)
            .subscribe(
            data => {
                this._mApp.HideLoader();
                this._toastrService.success(data.json().Result, '');
                this._router.navigate(['/equipments']);
            },
            error => {
                this._mApp.HideLoader();
                this._toastrService.error(error.json().Result, '');
            }
            )
    }
}